"use client";

import { Vehicle } from "@/components/package-components/types";
import { InventoryProps } from "../../../../mock";
import styles from "./optionals-variant-02.module.scss";
import Chip from "@/components/package-components/non-editable/misc/chip";

export default function OptionalVariant02({ id, data }: InventoryProps) {
  const vehicle = (data?.vehicle as Vehicle) || null;
  const features = vehicle?.features?.split(",") ?? [];

  return (
    <section className={`${styles.information} information-${id}`}>
      <h2>Opcionais</h2>

      <div className={`${styles["info-wrapper"]} info-wrapper-${id}`}>
        <ul className={`${styles["features-list"]} features-list-${id}`}>
          {features.map((feature, index) => (
            <li key={index} className={styles["features-list__item"]}>
              <Chip useSmall usePaper>
                {feature}
              </Chip>
            </li>
          ))}
        </ul>
      </div>

      <div className={`${styles.about} about-${id}`}>
        <h2>Sobre este carro</h2>
        <p>{vehicle?.generalDescription}</p>
      </div>
    </section>
  );
}
